import { endOfToday, startOfDay, subDays } from 'date-fns'

import { type EPlanName, FREE_PLANS } from '@albacross/types'

// Free plans see too little traffic for a fortnight to be representative, so they get a longer lookback.
const FREE_PLAN_PERIOD_DAYS = 30
const PAID_PLAN_PERIOD_DAYS = 14

export type LeadsUsageEstimation = {
  estimatedMonthly: number
  estimatedLow: number
  estimatedHigh: number
  days: number
  start: string
  end: string
}

export const buildEstimatedLeadsUsageQuery = (planName?: EPlanName) => {
  const period = planName && FREE_PLANS.includes(planName) ? FREE_PLAN_PERIOD_DAYS : PAID_PLAN_PERIOD_DAYS

  const startDate = startOfDay(subDays(endOfToday(), period))
  const endDate = endOfToday()

  return { start: startDate.toISOString(), end: endDate.toISOString() }
}
